// extracted by mini-css-extract-plugin
export var icon = "_bu-3";
export var subtitle = "_bu-2";
export var title = "_bu-1";
export var value = "_bu-0";